/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Allocation_And_ConnectiInputs */

const en_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain allocation and connectivity management.`)
};

const es_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignación de dominio y gestión de conectividad.`)
};

const fr_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation de domaine et gestion de la connectivité.`)
};

const de_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domainzuweisung und Verbindungsmanagement.`)
};

const ja_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドメインの割り当てと接続管理。`)
};

const zh_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`域名分配和连接管理。`)
};

const ar_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخصيص النطاق وإدارة الاتصال.`)
};

const id_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alokasi domain dan manajemen konektivitas.`)
};

const it_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocazione del dominio e gestione della connettività.`)
};

const ru_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Распределение доменов и управление подключениями.`)
};

const pt_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alocação de domínio e gerenciamento de conectividade.`)
};

const ko_domain_allocation_and_connecti = /** @type {(inputs: Domain_Allocation_And_ConnectiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도메인 할당 및 연결 관리.`)
};

/**
* | output |
* | --- |
* | "Domain allocation and connectivity management." |
*
* @param {Domain_Allocation_And_ConnectiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_allocation_and_connecti = /** @type {((inputs?: Domain_Allocation_And_ConnectiInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Allocation_And_ConnectiInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_allocation_and_connecti(inputs)
	if (locale === "es") return es_domain_allocation_and_connecti(inputs)
	if (locale === "fr") return fr_domain_allocation_and_connecti(inputs)
	if (locale === "de") return de_domain_allocation_and_connecti(inputs)
	if (locale === "ja") return ja_domain_allocation_and_connecti(inputs)
	if (locale === "zh") return zh_domain_allocation_and_connecti(inputs)
	if (locale === "ar") return ar_domain_allocation_and_connecti(inputs)
	if (locale === "id") return id_domain_allocation_and_connecti(inputs)
	if (locale === "it") return it_domain_allocation_and_connecti(inputs)
	if (locale === "ru") return ru_domain_allocation_and_connecti(inputs)
	if (locale === "pt") return pt_domain_allocation_and_connecti(inputs)
	return ko_domain_allocation_and_connecti(inputs)
});